import React, { useState, useEffect } from "react";
import "../../../../assets/scss/home.scss";
import "../../../../assets/scss/tests.scss";
import "flatpickr/dist/flatpickr.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import PaginationAnonymousResultWritten from "../../../../components/tables/paginationAnonymousResultWritten";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import ProgressBar from "@ramonak/react-progress-bar";
import logo from "@src/assets/images/smartStudyLogo.svg";
import Swal from "sweetalert2";

const AnonymousResultWritten = ({
    array,
    testType,
    note_id,
    isData,
    test_id,
    noteData,
    canDoIt,
    courseName,
    firstName,
    lastName,
    test_name,
    guid,
    score,
}) => {
    const location = useLocation();

    const [isChange, setIsChange] = useState(false);
    const [array2, setArray] = useState(array);
    const [loadingData, setLoadingData] = useState(true);
    const [showProblem, setShowProblem] = useState(false);
    const [resultData, setResultData] = useState("");
    const history = useHistory();

    const [collCount, setCollCount] = useState(0);

    function checkTypeTest(count) {
        if (testType.length > 1) {
            return `Written - ${count} Questions`;
        } else {
            return `${testType[0]} - ${count} Questions`;
        }
    }

    const deleteQuestion = async (id) => {
        
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                setArray(array.filter((item) => item.id !== id));
                setIsChange(true);
            }
            setLoadingData(true);
        });
    };

    useEffect(() => {
        // findTestsById();
    }, []);

    return loadingData ? (
       
            <div>
                <div className="homeCard resultCard mt-4">
                    
                    <div className="accountingHeaderContent mt-4">
                        <h1>{test_name}</h1>
                    </div>
                    <div className="testType">
                        <div>
                            <span>{checkTypeTest(array2.length)}</span>
                        </div>
                    </div>

                    <div className="pgItems">
                        <PaginationAnonymousResultWritten
                            itemsPerPage={4}
                            items={array2}
                            scoreResult={score}
                            test_id={test_id}
                            isCreate={true}
                            testType={testType}
                            isData={isData}
                            note_id={note_id}
                            test_name={test_name}
                            courseName={courseName}
                            firstName={firstName}
                            deleteQuestion={deleteQuestion}
                            lastName={lastName}
                            guid={guid}
                        />
                    </div>
                </div>
            </div>
        
    ) : (
        <div>
            <div className="fallback-spinner app-loader progres">
                <img className="fallback-logo" src={logo} alt="logo" />
                <div className="loading loadingDiv">
                    <div className="effect-1 effects"></div>
                    <div className="effect-2 effects"></div>
                    <div className="effect-3 effects"></div>
                </div>
                <ProgressBar completed={collCount} />
            </div>
        </div>
    );
};

export default AnonymousResultWritten;
